import React from "react"
import { BrowserRouter as Router, Routes, Route } from "react-router-dom"
import { SortProvider } from "./components/SortContext"
import HomePage from "./pages/HomePage"
import InfoPage from "./pages/InfoPage"
// import { MoodPage } from "./pages/MoodPage"
import SpyderCSU from "./pages/SpyderCSU"
import NikeATA from "./pages/NikeATA"
import LeviRespirate from "./pages/LeviRespirate"
import ScandinavianNeckGaiter from "./pages/ScandinavianNeckGaiter"
import BudaiWallet from "./pages/BudaiWallet"
import CanoeBag from "./pages/CanoeBag"
import UnderArmourRookie from "./pages/UARookieProject"
import SagaAdaptiveApparel from "./pages/SagaAdaptiveApparel"
import AdaptiveStudy from "./pages/AdaptiveStudy"
import FootwearDesign from "./pages/FootwearDesign"
import AloApparelBrief from "./pages/AloApparelBrief"

function App() {
    return (
        <SortProvider>
        <Router>
            <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/info" element={<InfoPage />} />
                {/* Temporarily hidden: <Route path="/mood" element={<MoodPage />} /> */}
                <Route path="/spydercsu" element={<SpyderCSU />} />
                <Route path="/nike-ata" element={<NikeATA />} />
                <Route path="/levi-respirate" element={<LeviRespirate />} />
                <Route path="/scandinavian-neck-gaiter" element={<ScandinavianNeckGaiter />} />
                <Route path="/budai-wallet" element={<BudaiWallet />} />
                <Route path="/canoe-bag" element={<CanoeBag />} />
                <Route path="/under-armour-second-nature" element={<UnderArmourRookie />} />
                <Route path="/saga-adaptive-apparel" element={<SagaAdaptiveApparel />} />
                <Route path="/adaptive-study" element={<AdaptiveStudy />} />
                <Route path="/senior-footwear-design-prototype" element={<FootwearDesign />} />
                <Route path="/alo-apparel-brief" element={<AloApparelBrief />} />
            </Routes>
        </Router>
        </SortProvider>
    )
}

export default App